exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cijferverantwoording-js": () => import("./../../../src/pages/cijferverantwoording.js" /* webpackChunkName: "component---src-pages-cijferverantwoording-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-provincies-js": () => import("./../../../src/pages/provincies.js" /* webpackChunkName: "component---src-pages-provincies-js" */)
}

